export default "__VITE_ASSET__Y$uYXFXj__"